import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button,
} from "shards-react";

const UserAccountDetails = ({
  onUpdateProfile,
  onchange,
  userDetails,
  title,
  onchangePassword,
  password,
  onUpdatePassword,
  loading,
  isupdateloading,
}) => (
  <React.Fragment>
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feFirstName">Full Name</label>
                    <FormInput
                      name={"fullname"}
                      id="feFirstName"
                      placeholder="First Name"
                      value={userDetails.fullname}
                      onChange={(e) => onchange(e)}
                    />
                  </Col>
                  {/* Last Name */}
                  {/* <Col md="6" className="form-group">
                  <label htmlFor="feLastName">Last Name</label>
                  <FormInput
                    id="feLastName"
                    placeholder="Last Name"
                    value="Brooks"
                    onChange={() => {}}
                  />
                </Col> */}
                </Row>
                <Row form>
                  {/* Email */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feEmail">Email</label>
                    <FormInput
                      type="email"
                      id="feEmail"
                      value={userDetails.email}
                      placeholder="Email Address"
                      disabled
                      autoComplete="email"
                    />
                  </Col>
                  {/* Password */}
                  {/* <Col md="6" className="form-group">
                  <label htmlFor="fePassword">Password</label>
                  <FormInput
                    type="password"
                    id="fePassword"
                    placeholder="Password"
                    value="EX@MPL#P@$$w0RD"
                    onChange={() => {}}
                    autoComplete="current-password"
                  />
                </Col> */}
                </Row>

                <Row form>
                  {/* Address */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feEmail">Address</label>
                    <FormInput
                      id="feAddress"
                      name={"address"}
                      placeholder="Address"
                      value={userDetails.address}
                      onChange={(e) => onchange(e)}
                    />
                  </Col>
                  {/* Password */}
                  {/* <Col md="6" className="form-group">
                  <label htmlFor="fePassword">Password</label>
                  <FormInput
                    type="password"
                    id="fePassword"
                    placeholder="Password"
                    value="EX@MPL#P@$$w0RD"
                    onChange={() => {}}
                    autoComplete="current-password"
                  />
                </Col> */}
                </Row>
                {/* <FormGroup>
                <label htmlFor="feAddress">Address</label>
                <FormInput
                  id="feAddress"
                  placeholder="Address"
                  value="1234 Main St."
                  onChange={() => {}}
                />
              </FormGroup>
               */}
                {/* <Row form>
                <Col md="6" className="form-group">
                  <label htmlFor="feCity">City</label>
                  <FormInput
                    id="feCity"
                    placeholder="City"
                    onChange={() => {}}
                  />
                </Col>
                <Col md="4" className="form-group">
                  <label htmlFor="feInputState">State</label>
                  <FormSelect id="feInputState">
                    <option>Choose...</option>
                    <option>...</option>
                  </FormSelect>
                </Col>
                <Col md="2" className="form-group">
                  <label htmlFor="feZipCode">Zip</label>
                  <FormInput
                    id="feZipCode"
                    placeholder="Zip"
                    onChange={() => {}}
                  />
                </Col>
              </Row>
               */}
                <Row form>
                  {/* Description */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feDescription">Description</label>
                    <FormTextarea
                      name={"description"}
                      value={userDetails.description}
                      onChange={(e) => onchange(e)}
                      id="feDescription"
                      rows="5"
                    />
                  </Col>
                </Row>
                <Button
                disabled={loading}
                
                onClick={onUpdateProfile} theme="accent">
                {isupdateloading && <i className="mr-1 fa fa-refresh fa-spin"></i>}{" "}

                  Update Account
                </Button>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
    <Card>
      <CardHeader className="border-bottom">
        <h6 className="m-0">Account Setting</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form>
                <Row form>
                  {/* Password */}
                  <Col md="6" className="form-group">
                    <label htmlFor="fePassword"> Old password</label>
                    <FormInput
                      type="password"
                      name={"password"}
                      id="fePassword"
                      placeholder="Old Password"
                      value={password.password}
                      onChange={(e) => {onchangePassword(e)}}
                      autoComplete="current-password"
                    />
                  </Col>
                </Row>

                <Row form>
                  {/* Password */}
                  <Col md="6" className="form-group">
                    <label htmlFor="fePassword">New Password</label>
                    <FormInput
                      type="password"
                      name={"newpassword"}
                      id="newPassword"
                      placeholder="Enter New Password"
                      value={password.newpassword}

                      onChange={(e) => {onchangePassword(e)}}
                      autoComplete="current-password"
                    />
                  </Col>
                </Row>
                <Row form>
                  {/* Password */}
                  <Col md="6" className="form-group">
                    <label htmlFor="fePassword">Confirm Password</label>
                    <FormInput
                      type="password"
                      name={"confirmpassword"}
                      id="confirmpassword"
                      placeholder="Enter Confirm Password"
                      value={password.confirmpassword}
                      onChange={(e) => {onchangePassword(e)}}
                      autoComplete="current-password"
                    />
                  </Col>
                </Row>
                <Button
                disabled={loading}
                onClick={onUpdatePassword} theme="accent">
                {loading && <i className="mr-1 fa fa-refresh fa-spin"></i>}{" "}
                  Update Password
                </Button>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  </React.Fragment>
);

UserAccountDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
};

UserAccountDetails.defaultProps = {
  title: "Account Details",
};

export default UserAccountDetails;
